import { ALTERAR_DETALHAMENTO_VEICULO, BUSCAR_VEICULOS, FILTRAR_RESUMO_VEICULO } from '../../actions/types'

const initialState = undefined

const stateInicial = {
  veiculos: [],
  resumoVeiculo: [],
  total: 0
}

export default function reducerBuscarVeiculos(state = stateInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_VEICULOS: {
      const dados = action.payload.data;

      return {
        ...state,
        veiculos: dados && dados.veiculos,
        resumoVeiculo: dados && dados.veiculos,
        total: dados && dados.total
      };
    }

    case ALTERAR_DETALHAMENTO_VEICULO: {      
      const veiculo = action.payload;
      
      let indice = 0;
      state.veiculos.findIndex((v, index) => {
        if (v.id === veiculo.id) {          
          indice = index;
          return index
        }          
      });
      
      const novoVeiculo = Object.assign({}, veiculo, { exibirDetalhe: !veiculo.exibirDetalhe });      
      const novo = [...state.veiculos];
      novo[indice] = novoVeiculo;
      
      return {
        ...state,
        veiculos: novo
      }
    }

    case FILTRAR_RESUMO_VEICULO: {
      return {
        ...state,
        veiculos: action.payload.resumoVeiculo.filter(
          l => (l.descricao && l.descricao.toLowerCase().includes(action.payload.texto.toLowerCase()) || (l.mapaVeiculoDto && l.mapaVeiculoDto.quantidadeAssentos == parseInt(action.payload.texto)))
        )
      };
    }

    default: {
      return state
    }
  }
}
